import { useContext } from 'react';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { useSelectedItems } from 'src/modules/contentList/components/bulkActions/hooks/useSelectedItems';
import { SelectedContentContext } from 'src/modules/contentList/contexts/selectedContentContext';
export default function useSelectedContent() {
    const { contentListConceptToggle } = useHostContext();
    const conceptListControl = useContext(SelectedContentContext);
    // TODO: Remove useSelectedItems after list rollout
    const legacyListControl = useSelectedItems();
    if (contentListConceptToggle) {
        return {
            pages: conceptListControl.selectedPageIds,
            modules: conceptListControl.selectedModuleIds,
            total: conceptListControl.selectedContentCount,
            hasPublished: conceptListControl.hasPublished,
            hasUnpublished: conceptListControl.hasUnpublished
        };
    }
    return legacyListControl;
}
